const LOCALSTORAGE_EXPIRY_PERIOD = 24 * 3600000 * 7
const LOCALSTORAGE_EXPIRY_PERIOD_LONG = 24 * 3600000 * 30

const ZH_CN = 'zh_CN'
const EN_US = 'en_US'

const EDIT_ADD = 1
const EDIT_UPDATE = 2

const LODING_PORT = 1
const DISCHARGE_PORT = 2

const TASK_TYPE_BALLAST = '1'
const TASK_TYPE_LOADING = '2'
const TASK_TYPE_DISCHARING = '3'
const TASK_TYPE_BUNKER = '4'
const TASK_TYPE_CANAL = '5'
const TASK_TYPE_PASSING = '6'
const TASK_TYPE_ROUTING = '7'

const TASK_TYPE_ARR = [
  { label: 'ballast', value: TASK_TYPE_BALLAST },
  { label: 'loading', value: TASK_TYPE_LOADING },
  { label: 'discharging', value: TASK_TYPE_DISCHARING },
  { label: 'bunker', value: TASK_TYPE_BUNKER },
  { label: 'canal', value: TASK_TYPE_CANAL },
  { label: 'passing', value: TASK_TYPE_PASSING },
  { label: 'routing', value: TASK_TYPE_ROUTING }
]

const TASK_TYPE_MAP = {
  1: 'ballast',
  2: 'loading',
  3: 'discharging',
  4: 'bunker',
  5: 'canal',
  6: 'passing',
  7: 'routing'
}

const BASEMAPS = [
  {
    url: require('@/assets/basemap/oceans.jpg'),
    title: 'Ocean Map',
    map: 'oceans'
  },
  {
    url: require('@/assets/basemap/topo.jpg'),
    title: 'World Topo Map',
    map: 'topo'
  },
  {
    url: require('@/assets/basemap/hybrid.jpg'),
    title: 'Bing Map',
    map: 'hybrid'
  },
  {
    url: require('@/assets/basemap/streets.jpg'),
    title: 'World Street Map',
    map: 'streets'
  },
  {
    url: require('@/assets/basemap/osm.jpg'),
    title: 'Offline Map',
    map: 'osm'
  },
  {
    url: require('@/assets/basemap/satellite.jpg'),
    title: 'World Light Gray Map',
    map: 'satellite'
  }
]

export default {
  LOCALSTORAGE_EXPIRY_PERIOD,
  LOCALSTORAGE_EXPIRY_PERIOD_LONG,
  ZH_CN,
  EN_US,
  EDIT_ADD,
  EDIT_UPDATE,
  BASEMAPS,

  TASK_TYPE_ARR,
  TASK_TYPE_MAP,

  TASK_TYPE_BALLAST,
  TASK_TYPE_LOADING,
  TASK_TYPE_DISCHARING,
  TASK_TYPE_BUNKER,
  TASK_TYPE_CANAL,
  TASK_TYPE_PASSING,
  TASK_TYPE_ROUTING

}
